// src/components/ContactFormModal.jsx
import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ContactFormModal = ({ onClose }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://codespace.fi/fusionx/play2visitform.php", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error("Failed to send");
      setSent(true);
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      alert(t('contact.error'));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900 text-white rounded-lg shadow-xl w-full max-w-lg relative p-6">
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-2 right-2 text-gray-400 hover:text-white text-xl"
        >
          &times;
        </button>

        {sent ? (
          <p className="text-green-400 text-center">
            {t('contact.thankYou')}
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h3 className="text-2xl font-bold mb-4">
              {t('contact.title')}
            </h3>

            <div>
              <label className="block text-gray-300 mb-1" htmlFor="name">
                {t('contact.name')}
              </label>
              <input
                id="name"
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-1" htmlFor="email">
                {t('contact.email')}
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-1" htmlFor="message">
                {t('contact.message')}
              </label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                rows="4"
                required
                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700"
              />
            </div>

            <button
              type="submit"
              className="bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600
                         px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300
                         flex items-center gap-2"
            >
              {t('contact.send')}
              <ChevronRight className="w-5 h-5" />
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactFormModal;
